<template>
  <div class="w-full">
    <vue-multiselect
      :value="value" :options="options" :label="label" :track-by="trackBy" :multiple="true" :close-on-select="false" :clear-on-select="false" :limit="3" @input="input"
    ></vue-multiselect>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    name: "Multiselect",
    props: {
      value: {
        required: true
      },
      options: {
        required: true
      },
      label: {
        required: true
      },
      trackBy: {
        required: true
      }
    },
    components: {
      'vue-multiselect': Multiselect
    },
    data() {
      return {
        selected: {}
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
